import { combineReducers } from 'redux';
import { takeEvery, call } from 'redux-saga/effects';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';

export const FETCH_COLLEGE_PROGRAMS = 'sites/FETCH_COLLEGE_PROGRAMS';

const list = (state = [], action) => {
    switch (action.type) {
        case actionKey.success(FETCH_COLLEGE_PROGRAMS):
            return action.payload.programs;
        default:
            return state;
    }
};

const listCustom = (state = [], action) => {
    switch (action.type) {
        case actionKey.success(FETCH_COLLEGE_PROGRAMS):
            return action.payload.programsCustom;
        default:
            return state;
    }
};


const family = (state = false, action) => {
    switch (action.type) {
        case actionKey.success(FETCH_COLLEGE_PROGRAMS):
            return action.payload.family;
        default:
            return state;
    }
};

export default combineReducers({
    list,
    listCustom,
    family,
});

export const fetchCollegeProgramsAction = () => ({
    type: FETCH_COLLEGE_PROGRAMS,
});

export const fetchCollegeCustomProgramsAction = () => ({
    type: FETCH_COLLEGE_PROGRAMS,
});

export function* rootSaga() {
    yield [
        takeEvery(FETCH_COLLEGE_PROGRAMS, fetchCollegePrograms),
    ];
}

function* fetchCollegePrograms({ type }) {
    yield call(request, {
        url: '/api/colleges/programs',
        type,
        options: {
            method: 'GET',
        },
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/college-programs.js